<template>
  <div class="h-full overflow-hidden">
    <tableButtonGroup class="mt-10px" v-model="activeTab" :list="tabList" @btn-click="tabClick" />
    <div class="icon-search__input mt-10px mb-10px">
      <el-input placeholder="输入名称搜索" v-model="treeKeyWords" size="small" clearable>
        <i slot="append" class="el-icon-search cursor-pointer"></i>
      </el-input>
    </div>
    <div class="tree-box" v-loading="treeLoading" element-loading-background="rgba(0, 0, 0, 0.5)">
      <el-tree
        class="three-tree"
        ref="treeDom"
        node-key="id"
        :default-expand-all="false"
        :data="treeData"
        :props="{ children: 'children', label: 'name' }"
        :filter-node-method="filterTreeNode"
        :current-node-key="currentNodeInfo.id"
        :default-expanded-keys="defaultExpandKey"
      >
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <div @click="handletreeClick(data)">{{ node.label }}</div>
        </div>
      </el-tree>
    </div>
    <!-- 全局loading -->
    <div
      class="mask"
      v-if="loading"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
      :element-loading-text="'系统加载中'"
    ></div>
  </div>
</template>

<script>
import tableButtonGroup from '@/components/cockpit/TableButtonGroup'
import {
  VirtualTagTreeApi,
  VirtualTagTreeTagRelationApi,
  TagAnimationApi,
} from '@wiz-api/tag-roam-sis-management'

import {
  matchNodesTreeEasy,
  matchImgWithDiff,
  matchImg,
  batchNodesUV,
} from '@/utils/dynamicEffect/uvPipe'
import { DevicePointRelationApi } from '@wiz-api/tag-management'
import { batchFormRotationAction } from '@/utils/dynamicEffect/rotate'
import batchAnimation from '@/utils/dynamicEffect/batchAnimation'
import { loadParticle } from '@/utils/dynamicEffect/particle'
import EventBus from '@/assets/js/EventBus'
import { computedTextWidth } from '@/utils/basicTool'

const virtualTagTreeApi = new VirtualTagTreeApi()
const tagAnimationApi = new TagAnimationApi()
const virtualTagTreeTagRelationApi = new VirtualTagTreeTagRelationApi()
const devicePointRelationApi = new DevicePointRelationApi()
const baseUrl = Wiz.GetModuleServer()
const PROJECT_NAME = Wiz.globalSettings.globalConfig?.modelSetting?.folderName || 'SAAS'
const visualizationSetting =
  Wiz.globalSettings.dynamicModules.modules['visualization-cockpit']?.config
const MAX_LOD = visualizationSetting?.deviceDistanceConfig?.maxLod || 1000
const MIN_LOD = visualizationSetting?.deviceDistanceConfig?.minLod || 0
const headerComponentCode = visualizationSetting.headerComponentCode
const websocketServer = visualizationSetting?.websocketServer
let perspective = {}
const signalR = require('@microsoft/signalr')
// 面板颜色
const alarmLevelMap = {
  // 报警等级面板展示颜色
  title: {
    color: 'data://apps/gat/img/panel-title.png',
    imgId: '',
  },
  normal: {
    color: 'data://apps/gat/img/panel-normal.png',
    imgId: '',
  },
  // slight: {
  //   color: 'data://apps/gat/img/panel-yellow.png',
  //   imgId: '',
  // },
  // middle: {
  //   color: 'data://apps/gat/img/panel-orange.png',
  //   imgId: '',
  // },
  // serious: {
  //   color: 'data://apps/gat/img/panel-red.png',
  //   imgId: '',
  // },
}
// 面板id数组
let markerIds = []
export default {
  name: 'sisSystem',
  components: {
    tableButtonGroup,
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
    // 静态资源文件前缀路径
    staticFilePath() {
      return `data://../apps/${this.modelSetting.folderName}/digitalSimulation`
    },
  },
  props: {
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    labelList: {
      type: Array,
      defalut: () => {
        return []
      },
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      activeTab: '三维',
      tabList: ['三维', '设备资料'],
      treeKeyWords: '',
      loading: false,
      treeLoading: false,
      treeData: [],
      defaultExpandKey: [],
      currentNodeInfo: {},
      visibleList: [], // 所有设备模型树指针item
      showDeviceManage: false, // 显示设备资料弹框
      animationList: [],
      dynInfo: {
        nodes: [], // node指针
        clips: [], // clip指针
        particleNodes: [], // 粒子节点指针
      },
      modelSourceId: '',
      textImgId: '',
      markerList: [],
      pointData: [],
      connection: null,
    }
  },
  watch: {
    treeKeyWords(val) {
      val = val.replace(/(^\s*)|(\s*$)/g, '')
      this.$refs.treeDom.filter(val)
    },
    visibleList() {
      this.sendInfoToRightDialog('detail', { id: this.currentNodeInfo.id })
    },
    transferProps(val, oValue) {
      if (val.id !== oValue.id && this.treeData.length > 0) {
        this.getTreeData()
      }
    },
  },
  methods: {
    setCheckDisable(bol) {
      const disableEvent = new CustomEvent('setCheckDisable', {
        detail: {
          disable: bol,
        },
      })
      window.dispatchEvent(disableEvent)
    },
    setLabelUncheck() {
      const newLabelList = _.map(this.labelList, (item) => {
        const obj = _.cloneDeep(item)
        obj.checked = false
        return obj
      })
      const hiddenList = _.filter(this.labelList, (item) => {
        return item.checked
      })
      const hiddenEvent = new CustomEvent('setComponentVisible', {
        detail: {
          type: 'hidden',
          hiddenList,
          newLabelList,
        },
      })
      window.dispatchEvent(hiddenEvent)
    },
    tabClick(item) {
      if (item === '设备资料') {
        this.sendInfoToRightDialog('mainComponent', { id: this.currentNodeInfo.id })
      } else {
        this.sendInfoToRightDialog('close')
      }
    },
    // 传递信息给二级弹框
    sendInfoToRightDialog(type, data = {}) {
      this.$emit('transferEvent', {
        toCom: { code: 'DeviceList', origin: 'SisSystem', name: '设备资料' },
        type,
        props: data,
      })
    },
    /**
     * @description: 搜索区域树
     * @param {*} value
     * @param {*} data
     * @return {*}
     */
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 点击树
    async handletreeClick(data) {
      if (!data.parentId) {
        if (this.currentNodeInfo.id === data.id) return
        this.currentNodeInfo = data
        // 点击跟节点
        this.clickRootTree()
        if (this.activeTab !== '三维') {
          this.activeTab = '三维'
          this.tabClick('三维')
        }
        return
      }
      if (data.children && data.children.length) return
      if (this.currentNodeInfo.id === data.id) return
      this.currentNodeInfo = { ...data }
      await this.destroyDyn()
      // await this.destoryMarker()
      // await this.deletePointPanel()
      await this.getTagList()
      if (this.activeTab !== '设备资料') {
        this.activeTab = '设备资料'
        this.tabClick('设备资料')
      }
    },
    // 点击树的根节点
    async clickRootTree() {
      this.visibleList = []
      await this.setRootModelShow(true)
      await this.backInitPositon()
      await this.destroyDyn()
      // await this.destoryMarker()
      // await this.deletePointPanel()
    },
    // 获取左侧树
    async getTreeData() {
      this.treeLoading = true
      const [err, res] = await virtualTagTreeApi.getDisplayVirtualTagTree({
        sceneId: this.sourceId,
      })
      if (!err) {
        // 自动展开根节点
        if (Array.isArray(res) && res.length > 0) {
          const rootNode = res[0]
          this.defaultExpandKey = [rootNode.id]
        }
        this.treeData = Object.freeze(res)
        if (this.transferProps?.id && this.transferProps.toDefaultOpen === 'SisSystem') {
          // 有默认选中的树id
          this.currentNodeInfo.id = this.transferProps.id
          this.defaultExpandKey = [...this.defaultExpandKey, this.transferProps.id]
          this.$nextTick(async () => {
            this.$refs.treeDom.setCurrentKey(this.transferProps.id)
            await this.getTagList()
            if (this.activeTab !== '设备资料') {
              this.activeTab = '设备资料'
              this.tabClick('设备资料')
            }
            this.transferProps.id = ''
            this.transferProps.toDefaultOpen = ''
          })
        }
      }
      this.treeLoading = false
    },
    // 获取显示的三维设备
    /* eslint-disable no-await-in-loop */
    async getTagList() {
      this.loading = true
      const [err, res] = await virtualTagTreeTagRelationApi.getTagDetailInfoByVirtualTagTreeIdId({
        virtualTagTreeId: this.currentNodeInfo.id,
      })
      if (!err) {
        const params = []
        res.datas?.forEach((item) => {
          params.push({
            code: item.tagCode,
          })
        })
        await this.getAnimationList()
        const codeRes = await this.player.Native.ModelTree.batchFindItemByCode(params)
        await this.setRootModelShow(false)
        const visibleList = []
        codeRes.forEach((resItem) => {
          resItem.item ? visibleList.push(resItem.item) : ''
        })
        this.player.Native.ModelTree.setItemVisible(visibleList, true)
        this.visibleList = visibleList

        if (res.perspective) {
          perspective = JSON.parse(res.perspective)
          this.player.Native.Camera.moveTo(perspective.eye, perspective.target, perspective.up, 1)
        }
        // await this.getShowDevice(res.datas || [])
        await this.createDyn()
      }
      this.loading = false
    },
    async getShowDevice(systemDevices) {
      if (!systemDevices.length) return
      const allDevices = await this.getAllDeviceList()
      const tempList = systemDevices.filter((item) => {
        return allDevices[item.tagCode]
      })
      // console.log('tempList', tempList)
      const pointMarkerList = []
      const codeList = []
      tempList.forEach((item) => {
        codeList.push(item.tagCode)
      })
      const aabbRes = await this.player.Native.ModelTree.batchCalcItemAabb(codeList)
      tempList.forEach((tagInfo, index) => {
        const position = aabbRes[index]
        if (position && position.aabb) {
          const leftBottom = position.aabb.max
          const rightTop = position.aabb.min
          const pos = [
            (leftBottom[0] + rightTop[0]) / 2,
            (leftBottom[1] + rightTop[1]) / 2,
            (leftBottom[2] + rightTop[2]) / 2,
          ]
          pointMarkerList.push({
            code: tagInfo.tagCode,
            name: tagInfo.tagName,
            pos,
          })
        }
      })
      // console.log('pointMarkerList', pointMarkerList)
      if (!this.textImgId) {
        this.textImgId = await this.player.Native.GisMarker.loadImage(
          `data://../apps/${PROJECT_NAME}/digitalSimulation/img/icon-text.png`
        )
      }
      const options = pointMarkerList.map((o) => {
        const len = this.getTextWidth(o.name)
        return {
          pos: o.pos,
          imgId: this.textImgId,
          imgSize: [len, 26],
          textFontSize: 15.0,
          breakWidth: -1,
          textColor: 0xffffffff,
          text: o.name || '',
          contentPadding: [10, 5, 0, 0],
          maxLod: MAX_LOD,
          minLod: MIN_LOD,
        }
      })
      const markerIdList = await this.player.Native.GisMarker.batchCreate(options)
      const markers = []
      pointMarkerList.forEach((item, index) => {
        markers.push({
          markerId: markerIdList[index],
          code: item.code,
          name: item.name,
          pos: item.pos,
        })
      })
      this.markerList = markers
    },
    // 获取所有设备列表
    async getAllDeviceList() {
      const res = await axios({
        method: 'GET',
        url: `${baseUrl}/openapi/devices/paged-list/V1.0?token=portal_js`,
        params: {
          pageNo: 1,
          pageSize: 9999,
          level: ['A', 'B'].join(','),
        },
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
      if (res.data && res.data.data) {
        const tempList = res.data.data.items || []
        // let tempList = res.data.data.items || []
        // const arr = [
        //   { code: 'obj-13', name: 'obj-13', id: 1 },
        //   { code: 'obj-14', name: 'obj-14', id: 2 },
        //   { code: 'obj-15', name: 'obj-15', id: 3 },
        //   { code: 'Box036', name: 'Box036', id: 4 },
        //   { code: 'PIPE-J0802-1#', name: '/PIPE-J0802-1#', id: 5 },
        //   { code: 'PIPE-J0802-2#', name: '/PIPE-J0802-2#', id: 6 },
        // ]
        // tempList = [...arr, ...tempList]
        const objMap = {}
        tempList.forEach((item) => {
          objMap[item.code] = item
        })
        return objMap
      }
      return {}
    },
    async setRootModelShow(show) {
      const root = await this.player.Native.ModelTree.getRootItems()
      const rootList = root.map((val) => {
        return val.item
      })
      this.player.Native.ModelTree.setItemVisible(rootList, show)
    },
    async destoryMarker() {
      const markerIdList = this.markerList.map((item) => {
        return item.markerId
      })
      this.markerList = []
      await this.player.Native.GisMarker.batchDestroy(markerIdList)
    },
    getTextWidth(text, font = '15px Arial') {
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      context.font = font
      const metrics = context.measureText(text)
      return Math.ceil(metrics.width) + 20
    },
    // 返回初始视角
    backInitPositon() {
      if (this.customProps?.sceneOptions?.jsonData) {
        const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
        const cameraParams = jsonData.cameraParams
          ? JSON.parse(jsonData.cameraParams)
          : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
        this.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
      }
    },
    async getAnimationList() {
      const [err, res] = await tagAnimationApi.getTagAnimationsByVirtualTagId({
        virtualTagId: this.currentNodeInfo.id,
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        const animationList = []
        res.forEach((item) => {
          item.tagCode = item.threeDimensionalObjectCode
          if (item.status) {
            animationList.push(item)
          }
        })
        this.animationList = animationList
      }
    },
    // 新建动效
    async createDyn() {
      const dynList = []
      const particleList = []
      this.animationList.forEach((item) => {
        if (['fire', 'gas'].includes(item.modelType)) {
          particleList.push(item)
        } else {
          dynList.push(item)
        }
      })
      await this.handelParticle(particleList)
      if (!dynList.length) {
        return
      }
      // 批量查询模型信息
      const codeItemList = [] // 批量将模型code查询对应item
      dynList.forEach((item) => {
        if (item.modelType === 'pipeFlow') {
          // 管道的convert父节点
          if (item.tagCode) {
            codeItemList.push({
              code: item.tagCode,
            })
          }
        } else if (item.tagCode) {
          // 其他动效convert子节点
          if (JSON.parse(item.config).dynForm) {
            codeItemList.push({
              code: JSON.parse(item.config).dynForm.clickTagCode,
            })
          }
        }
      })
      const itemList = await this.player.Native.ModelTree.batchFindItemByCode(codeItemList)
      // 批量convert
      const convertNodeList = []
      const visibleList = []
      const missingList = []
      itemList.forEach((item, index) => {
        if (item.item) {
          convertNodeList.push({
            item: item.item,
            parentItem: item.parentItem,
            replace: false,
            bReuseMaterial: false,
          })
          visibleList.push(item.item)
        } else {
          missingList.push(index)
        }
      })
      const nodeList = await this.player.Native.ModelTree.batchConvertToNode(convertNodeList)
      const nodeItemList = []
      for (let i = 0; i < convertNodeList.length; i += 1) {
        nodeItemList.push({
          parentItem: convertNodeList[i].parentItem,
          node: nodeList[i],
          recursive: true,
          isTemplate: false,
        })
      }
      await this.player.Native.ModelTree.batchCreateNodeItem(nodeItemList)
      await this.player.Native.ModelTree.setItemVisible(visibleList, false) // 隐藏modeltree
      missingList.forEach((item) => {
        nodeList.splice(item, 0, 0)
      })
      // 分动效类型处理
      let uvPipeList = [] // 管道渲染列表
      const MRList = [] // 旋转、位移action列表
      for (let i = 0; i < dynList.length; i += 1) {
        const dynInfo = dynList[i] // 后端动效配置信息
        const dynForm = JSON.parse(dynInfo.config).dynForm // 动效具体配置信息
        const itemInfo = itemList[i] // modeltree item指针list
        const ptr = nodeList[i] // convert的node list
        if (!itemInfo || !itemInfo.item || !ptr) {
          // eslint-disable-next-line no-continue
          continue
        }
        if (dynInfo.modelType === 'rotate') {
          // 旋转
          const axisOffset = dynForm.rotateCenter
          if (axisOffset[0] !== 0 && axisOffset[1] !== 0 && axisOffset[2] !== 0) {
            await this.player.Native.NodeProxy.moveAxis(ptr, axisOffset)
          }
          if (dynForm.rotateType === 'sustainRotate') {
            let shape = null
            if (dynForm.isSkew) {
              shape = await this.player.Native.ModelTree.getItemShapeInfo(itemInfo.item)
            }
            const baseData = {
              playerMode: 1,
              rotateSpeed: dynForm.defalutRspeed,
              axis: dynForm.rotateAxis,
              modeltreeQuat: shape,
            }
            const node = await batchFormRotationAction(ptr, baseData, dynInfo.tagCode)
            MRList.push(node)
          }
        } else if (dynInfo.modelType === 'pipeFlow') {
          // 管道
          // 处理直数组
          const flatTreeData = await this.player.Native.NodeProxy.getNodeChildrenRecursion(ptr)
          let matchNodes = []
          if (dynForm.addMode === 'easy') {
            // easy实施模式
            matchNodes = await matchNodesTreeEasy(dynForm.nodes, flatTreeData, true)
          } else if (dynForm.addMode === 'single') {
            // single实施模式
            matchNodes = [
              {
                activate: true,
                nodePtr: ptr,
                direction: dynForm.direction,
                flowValue: dynForm.flowValue,
                isRenderPipeFlow: dynForm.isRenderPipeFlow,
                size: dynForm.size,
              },
            ]
          }
          // console.log('matchNodes', matchNodes, dynForm.nodes)
          if (dynForm.isDiffMaterial) {
            matchImgWithDiff(matchNodes, this.staticFilePath)
          } else {
            matchImg(matchNodes, dynForm.materialType, this.staticFilePath)
          }
          uvPipeList = uvPipeList.concat(matchNodes)
        }
      }
      if (uvPipeList.length) {
        // 一次批量渲染
        for (let i = 0; i < uvPipeList.length; i += 1000) {
          const clipList = await batchNodesUV(uvPipeList.slice(i, i + 1000), this.player)
          this.dynInfo.clips = this.dynInfo.clips.concat(clipList)
        }
      }
      if (MRList.length) {
        // 一次批量渲染旋转和位移
        const clipList = await batchAnimation(MRList, this.player)
        // TODO: 可以直接用接口删除clips，不行的话只能拿指针删除
        this.dynInfo.clips = this.dynInfo.clips.concat(clipList)
      }
      this.dynInfo.nodes = nodeList // 保存node指针销毁用
    },
    // 动效销毁
    async destroyDyn() {
      await this.destoryParticle()
      const destroyNodes = [...this.dynInfo.nodes]
      this.dynInfo.nodes = []
      if (!destroyNodes.length) {
        return
      }
      for (let i = 0; i < destroyNodes.length; i += 1) {
        const node = destroyNodes[i]
        if (node) {
          await this.player.Native.NodeProxy.destroyNode(node)
        }
      }
      const uvMixer = await this.player.Native.AnimationMixer.getMixer('uv')
      const mrMixer = await this.player.Native.AnimationMixer.getMixer('mr')
      await this.player.Native.AnimationClip.clearClip(uvMixer)
      await this.player.Native.AnimationClip.clearClip(mrMixer)
    },
    // 处理粒子动效
    async handelParticle(particleList) {
      const particleNodes = []
      for (let i = 0; i < particleList.length; i += 1) {
        const dynInfo = particleList[i]
        const dynForm = JSON.parse(dynInfo.config).dynForm // 动效具体配置信息
        const baseData = {
          dynModel: dynInfo.modelType,
        }
        const { particleObject } = await loadParticle(baseData, dynForm)
        particleNodes.push(particleObject)
      }
      this.dynInfo.particleNodes = particleNodes
    },
    // 销毁粒子动效
    async destoryParticle() {
      const particleNodes = [...this.dynInfo.particleNodes]
      this.dynInfo.particleNodes = []
      for (let i = 0; i < particleNodes.length; i += 1) {
        const node = particleNodes[i]
        if (node) {
          await this.player.Native.NodeProxy.destroyNode(node)
        }
      }
    },
    // 监听设备台账tab切换事件
    onledgerChangeTab() {
      EventBus.$on('ledgerChangeTab', (data) => {
        this.$emit('transferEvent', {
          toCom: data.toCom,
          type: data.type,
          props: data.props,
        })
      })
    },
    // 标签点击
    async markerClick(data) {
      const markInfo = this.markerList.find((item) => {
        return item.markerId === data.markerId
      })
      if (markInfo) {
        this.$emit('transferEvent', {
          toCom: {
            code:
              headerComponentCode === 'CockpitHeaderDj'
                ? 'DeviceRealBasicInfoDJ'
                : 'DeviceRealBasicInfo',
            origin: 'SisSystem',
            name: '设备基础信息',
          },
          type: 'mainComponent',
          props: markInfo,
        })
        // 获取设备关联测点
        await this.getLinkPointList(markInfo.code)
        await this.createPointPanel(markInfo.pos, markInfo.name, markInfo.code)
      }
      const closeMarker = markerIds.filter((item) => {
        return item.type === 'CLOSE'
      })[0]
      if (data.markerId === closeMarker?.markerId) {
        // 关闭图标点击
        await this.deletePointPanel()
      }
    },
    // 获取关联测点列表
    async getLinkPointList(code) {
      const [err, res] = await devicePointRelationApi.getList({
        deviceCode: code,
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        res.items.forEach((item) => {
          item.value1 = item.value
        })
        this.pointData =
          res.items.map((item) => {
            item.value1 = '--'
            return item
          }) || []
      }
    },
    // 计算创建面板所有数据
    async createPointPanel(pos, name, kks) {
      // 创建新的面板之前先删除已经创建的面板
      await this.deletePointPanel()
      // 计算面板宽度
      let contents = [`设备名称：${name}`, `设备kks：${kks || ''}`]
      const pointContents = this.pointData.map((item) => {
        return `${item.pointName}：${item.value1}`
      })
      contents = contents.concat(pointContents)
      const maxLen = this.getContentWidth(contents)

      const nameMarker = {
        imgSize: [maxLen, 22],
        size: [maxLen, 22],
        textFontSize: 12.0,
        text: `设备名称：${name}`,
        contentPadding: [10, 5, 0, 0],
        nodeOffset: [0, 25],
        isTitle: true,
      }
      const kksMarker = {
        imgSize: [maxLen, 22],
        size: [maxLen, 22],
        textFontSize: 12.0,
        text: `设备kks：${kks || ''}`,
        contentPadding: [10, 5, 0, 0],
        nodeOffset: [0, 25 + 22],
        isTitle: false,
      }
      const markers = [nameMarker, kksMarker]
      for (let i = 0; i < this.pointData.length; i += 1) {
        const item = this.pointData[i]
        const pointMarker = {
          imgSize: [maxLen, 22],
          size: [maxLen, 22],
          textFontSize: 12.0,
          text: `${item.pointName}：${item.value1}`,
          contentPadding: [10, 5, 0, 0],
          nodeOffset: [0, 69 + i * 22],
          isTitle: false,
          pointId: item.pointId, // 每个测点标签都存储测点id,用作更新
        }
        markers.push(pointMarker)
      }
      for (let i = 0; i < markers.length; i += 1) {
        const item = markers[i]
        await this.createPointMakers(pos, item)
      }
      // await this.createSisMarker({ pos, nodeOffset: [maxLen, 25] })
      // await this.createTrendMarker({ pos, nodeOffset: [maxLen, 25 + 22] })
      await this.createCloseMarker({ pos, nodeOffset: [maxLen, 25] })
      this.subscribeDot(
        this.pointData.map((item) => {
          return {
            MeasuringPointId: String(item.pointId),
          }
        })
      )
    },
    // 创建关闭标签
    async createCloseMarker(detailInfo) {
      if (!detailInfo) return
      await this.player.Native.GisMarker.loadImage(
        'data://apps/gat/img/icon-close.png',
        async (id) => {
          const option = {
            pos: detailInfo.pos, // 定位点，世界坐标，三维向量
            nodeOffset: detailInfo.nodeOffset, // 相对定位点的偏移量，二维向量
            size: [20, 20],
            imgId: id, // 图片id
            visible: true,
            // maxLod: 50,
            // minLod: 0,
          }
          await this.player.Native.GisMarker.create(option, (markerId) => {
            markerIds.push({
              markerId,
              option,
              type: 'CLOSE',
            })
          })
        }
      )
    },
    // 删除标签面板
    async deletePointPanel() {
      // 清空测点订阅
      this.removeAllDot()
      // 删除标签
      if (markerIds.length > 0) {
        for (let i = 0; i < markerIds.length; i += 1) {
          const markerId = markerIds[i].markerId
          await this.player.Native.GisMarker.destroy(markerId)
        }
      }
      markerIds = []
    },
    // 更新标签面板
    async updatePointPanel() {
      for (let i = 0; i < this.pointData.length; i += 1) {
        const point = this.pointData[i]
        for (let j = 0; j < markerIds.length; j += 1) {
          const marker = markerIds[j]
          if (point.pointId === marker.pointId) {
            const newOption = JSON.parse(JSON.stringify(marker.option))
            newOption.text = `${point.pointName}：${point.value1}`
            await this.player.Native.GisMarker.update(marker.markerId, newOption)
            break
          }
        }
      }
    },
    // 创建设备三维标签
    async createPointMakers(pos, markerData) {
      // 判断img是否注册成功
      if (!alarmLevelMap.normal.imgId) {
        await this.creatBgImg()
      }
      // 获取maker背景图已注册id
      const imgId = markerData.isTitle ? alarmLevelMap.title.imgId : alarmLevelMap.normal.imgId
      const option = {
        pos,
        imgId,
        imgSize: markerData.imgSize,
        size: markerData.size,
        textFontSize: markerData.textFontSize,
        breakWidth: -1,
        textColor: 0xffffffff,
        text: markerData.text,
        contentPadding: markerData.contentPadding,
        // maxLod: 50,
        // minLod: 0,
        nodeOffset: markerData.nodeOffset,
      }
      const markerId = await this.player.Native.GisMarker.create(option)
      markerIds.push({
        markerId,
        pointId: markerData.pointId,
        option,
      })
    },
    // 创建三维面板背景图图片
    async creatBgImg() {
      // 创建好面板颜色
      Object.keys(alarmLevelMap).forEach((level) => {
        this.player.Native.GisMarker.loadImage(alarmLevelMap[level].color, (id) => {
          alarmLevelMap[level].imgId = id
        })
      })
    },
    // 根据内容计算出宽度
    getContentWidth(contents) {
      const contentLens = []
      for (let i = 0; i < contents.length; i += 1) {
        const content = contents[i]
        const contentLen = computedTextWidth(content, '14px') + 24
        contentLens.push(contentLen)
      }
      const maxLen = Math.max.apply(null, contentLens)
      return maxLen
    },
    /**
     * @param {Number/String} value - 要处理的值
     * @param {Number} index  - 要保留的位数
     */
    toFixed(value, index) {
      const newValue = parseFloat(value).toFixed(index)
      newValue.substring(0, newValue.lastIndexOf('.') + index)
      return newValue
    },
    // 订阅测点
    async subscribeDot(measuringPointIds) {
      await this.connection?.invoke('BulkAddDto', measuringPointIds)
    },
    // 清空订阅测点
    async removeAllDot() {
      try {
        await this.connection?.invoke('RemoveAllDto')
      } catch (e) {
        // throw e
      }
    },
    // 断开测点订阅webscoket
    async disconnectConenction() {
      try {
        await this.connection?.invoke('DisconnectedCurrentHub')
        this.connection = null
      } catch (e) {
        // throw e
      }
    },
    // 建立面板websocket连接,监听测点数据变化
    async initConenction() {
      // 建立连接
      const url = `${websocketServer}/iotQueryForJobManageHub`
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(url, {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .configureLogging(signalR.LogLevel.Information)
        .build()

      // console.log('connection created', this.connection)
      // 监听面板测点信息
      this.connection.on('MsgResult', async (data) => {
        // console.log('panel MsgResult', data)
        // console.log(this.pointData)
        data.forEach((item) => {
          item.time = this.dayjs(item.time).format('YYYY-MM-DD HH:mm:ss')
        })

        // 当前标记面板测点数据是否有更新
        let isUpdatePanelPointData = false
        /* eslint-disable */
        for (const measuringPoint of data) {
          for (const [index, point] of this.pointData.entries()) {
            if (measuringPoint.measuringPointId == point.pointId) {
              isUpdatePanelPointData = true
              this.$set(
                this.pointData[index],
                'value1',
                `${this.toFixed(measuringPoint.value, 2)}${point.pointUnit || ''}`
              )
            }
          }
        }

        // 测点数据更新，更新三维标记面板
        if (isUpdatePanelPointData) {
          await this.updatePointPanel()
        }
      })

      this.connection.onclose(() => {
        console.log('connection closed')
        this.connection = null
      })

      // 开始连接
      try {
        await this.connection.start()
      } catch (e) {
        console.log('connection error', e)
      }
    },
  },
  created() {
    // 订阅测点变化
    // this.initConenction()
    // this.creatBgImg()
    this.modelSourceId = this.sourceId
    this.setLabelUncheck()
    this.setCheckDisable(true)
    this.getTreeData()
    // this.player.Native.GisMarker.EventGisMarkerLClick.connect(this.markerClick)
    // // 监听设备台账tab切换事件
    // this.onledgerChangeTab()
  },
  async beforeDestroy() {
    // EventBus.$off('ledgerChangeTab')
    // await this.disconnectConenction()
    // await this.deletePointPanel()

    if (this.modelSourceId === this.sourceId) {
      await this.setRootModelShow(true)
      await this.backInitPositon()
      await this.destroyDyn()
    } else {
      await this.destoryParticle()
    }
    // this.destoryMarker()
    this.sendInfoToRightDialog('close')
    this.setCheckDisable(false)
    // this.player.Native.GisMarker.EventGisMarkerLClick.disconnect(this.markerClick)
  },
}
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.tree-box {
  padding: 10px;
  margin-bottom: 10px;
  // height: calc(100% - 148px);
  height: calc(100% - 94px);
  border: 1px solid #45f2eb33;
}

::v-deep.three-tree {
  overflow-y: auto;
  height: 100%;
  color: #fff;
  background-color: transparent !important;

  .el-tree-node__content:hover {
    background: #005d657f !important;
  }

  .el-tree-node.is-current > .el-tree-node__content {
    background: #005d657f !important;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background: #005d657f !important;
  }

  .custom-tree-node {
    width: 100%;
    font-size: 14px;
  }
}
</style>
